import React, { useState, useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import { db } from '@root/firebase';
import Layout from '@components/Layout';
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
  startAfter,
} from 'firebase/firestore';
import { useParams } from 'react-router-dom';

function Errors() {
  const { updateIsAdmin, globalUser, setGlobalUser } = useAuth();
  const { type } = useParams();

  const [errors, setErrors] = useState([]);
  const [lastDoc, setLastDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);

  const pageSize = 10;

  useEffect(() => {
    fetchErrors();
  }, []);

  const fetchErrors = async () => {
    setLoading(true);
    const errorsRef = collection(db, 'user_errors');
    let q = query(errorsRef, orderBy('timestamp', 'desc'), limit(pageSize));

    if (lastDoc) {
      q = query(
        errorsRef,
        orderBy('timestamp', 'desc'),
        startAfter(lastDoc),
        limit(pageSize)
      );
    }

    const snapshot = await getDocs(q);

    const newErrors = [];
    snapshot.forEach((doc) => {
      newErrors.push({ id: doc.id, ...doc.data() });
    });

    setErrors((prev) => [...prev, ...newErrors]);
    setLastDoc(snapshot.docs[snapshot.docs.length - 1]);
    setHasMore(snapshot.docs.length === pageSize);
    setLoading(false);
  };

  const handleLoadMore = () => {
    if (!loading && hasMore) {
      fetchErrors();
    }
  };

  return (
    <Layout isAdminPage={true}>
      <div className='row'>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-header'>
              <h4 className='card-title'>System Errors</h4>
              <p className='card-title-desc'>User Induced System Errors.</p>
            </div>
            <div className='card-body'>
              <div className='table-responsive'>
                <table className='table table-striped'>
                  <thead>
                    <tr>
                      <th>Timestamp</th>
                      <th>User</th>
                      <th>Page</th>
                      <th>Function</th>
                      <th>Message</th>
                    </tr>
                  </thead>
                  <tbody>
                    {errors.map((err) => (
                      <tr key={err.id}>
                        <td>
                          {err.details?.timestamp?.toDate
                            ? err.details.timestamp
                                .toDate()
                                .toLocaleDateString('en-GB', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: '2-digit',
                                })
                            : 'N/A'}
                        </td>

                        <td>{err.details?.userName}</td>
                        <td>{err.details?.page}</td>
                        <td>{err.details?.functionCode}</td>
                        <td>{err.details?.error?.message}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {hasMore && (
                  <div className='text-center mt-3'>
                    <button
                      className='btn btn-primary'
                      onClick={handleLoadMore}
                      disabled={loading}
                    >
                      {loading ? 'Loading...' : 'Load More'}
                    </button>
                  </div>
                )}
                {!hasMore && !loading && errors.length === 0 && (
                  <p>No errors found.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Errors;
